import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CollapseButton, ExpandButton } from "../../assets/icons";
import "./expand-collapse-button.scss";

const ExpandCollapseButton = ({ accordionId, collapsed, setCollapsed, toggled, setToggled }) => {
    const handleClick = () => {
        const accordions = document.getElementsByClassName(accordionId);
        for (const accordion of accordions) {
            if (collapsed) accordion.classList.add("show");
            else accordion.classList.remove("show");
        }
        setCollapsed(!collapsed);
        if (toggled && Array.isArray(toggled)) {
            const updatedToggled = toggled.map(t => {
                return { ...t, Toggled: collapsed };
            });
            setToggled(updatedToggled);
        }
    };

    return (
        <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 150 }}
            overlay={
                <Tooltip>
                    {collapsed ? "Expand all rows" : "Collapse all rows"}
                </Tooltip>
            }
        >
            <div className="expand-collapse-button" onClick={handleClick}>
                {collapsed ?
                    <img src={ExpandButton} alt="Expand All" /> :
                    <img src={CollapseButton} alt="Collapse All" />
                }
            </div>
        </OverlayTrigger>
    );
}

ExpandCollapseButton.propTypes = {
    accordionId: PropTypes.string.isRequired,
    collapsed: PropTypes.bool.isRequired,
    setCollapsed: PropTypes.func.isRequired,
    toggled: PropTypes.arrayOf(PropTypes.shape({
        Toggled: PropTypes.bool
    })),
    setToggled: PropTypes.func
};

export default ExpandCollapseButton;
